import {createUseStyles} from "react-jss";
import {Theme} from "../themes/default";

const useChallengeFinalStyle = createUseStyles((theme: Theme) => {
    return {
        container: {
            justifyContent:'center',
            alignContent: 'center',
            alignItems: 'center',
            backgroundColor: theme.colors.dark_chocolate,
            flexDirection: 'column',
            paddingTop: theme.spacing(3),
        },
        item:{
            display: 'flex',
            justifyContent:'center',
            alignContent: 'center',
            alignItems: 'center',
            paddingBottom: `${theme.spacing(5)}`,
        },
        logo: {
            width: '100%',
            [theme.breakpoints.down('lg')]:{
                width: '75%',
            }
        },
        motoText: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: 'max(2vh,2vw)',
            fontWeight: 'bold',
            textAlign: "center",
        },
        wrapperTeaserFrame: {
            padding: theme.spacing(3),
            marginTop: theme.spacing(10),
            [theme.breakpoints.down('lg')]:{
                marginTop: theme.spacing(0),
            }
        },
        teaserFrameTitle:{
            fontFamily: theme.fonts.poplar,
            color: theme.colors.latte_cream,
            fontSize: 'max(5vh,5vw)',
            fontWeight: 'bold',
            textAlign: "center",
        },
        teaserContainer: {
            justifyContent:'center',
            alignContent: 'center',
            alignItems: 'center',
            padding: `0 ${theme.spacing(5)} ${theme.spacing(0)} ${theme.spacing(5)}`,
            [theme.breakpoints.down('lg')]:{
                padding: `0 ${theme.spacing(2)} ${theme.spacing(0)} ${theme.spacing(2)}`,
            }
        },
        teaserItem: {
            display: 'flex',
            justifyContent:'center',
            alignContent: 'center',
            alignItems: 'center',
            padding: `0 ${theme.spacing(5)} ${theme.spacing(5)} ${theme.spacing(5)}`,
            [theme.breakpoints.down('lg')]:{
                padding: `0 ${theme.spacing(0)} ${theme.spacing(2)} ${theme.spacing(0)}`,
            }
        },
        accessText: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: 'max(2vh,2vw)',
            fontWeight: 'bold',
            textAlign: "center",
        },
        imgStep: {
            width: '100%',
            height: 'auto',
        },
        teaserTitle: {
            fontFamily: theme.fonts.poplar,
            color: theme.colors.latte_cream,
            fontSize: 'max(5vh,5vw)',
            fontWeight: 'bold',
            textAlign: "center",
            textTransform: 'uppercase',
            [theme.breakpoints.down('lg')]:{
                fontSize: 'max(4vh,4vw)',
            }
        },
        teaserText: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: 'max(2vh,2vw)',
            paddingBottom: `${theme.spacing(5)}`,
            textAlign: "center",
        },
        teaserTextSuccess:{
            fontFamily: theme.fonts.poplar,
            color: theme.colors.latte_cream,
            fontSize: 'max(5vh,5vw)',
            paddingBottom: `${theme.spacing(5)}`,
            textAlign: "center",
            fontWeight: 'lighter',
            letterSpacing: '5px',
        },
        prizesText: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: 'max(2vh,2vw)',
            paddingTop: `${theme.spacing(5)}`,
            paddingBottom: `${theme.spacing(5)}`,
            textAlign: "center",
            [theme.breakpoints.down('lg')]:{
                padding: `${theme.spacing(5)} ${theme.spacing(2)} ${theme.spacing(5)} ${theme.spacing(2)}`,
            }
        },
        recommendGroupText: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: 'max(2vh,2vw)',
            textAlign: "center",
            paddingBottom: `${theme.spacing(5)}`,
            '& a': {
                textDecoration: 'underline',
                color: theme.colors.latte_cream,
            },
            [theme.breakpoints.down('lg')]:{
                padding: `${theme.spacing(0)} ${theme.spacing(2)} ${theme.spacing(5)} ${theme.spacing(2)}`,
            }
        },
        barAccessText:{
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: 'max(2vh,2vw)',
            textAlign: "center",
            fontWeight: 'bold',
        },
        messageCzech:{
            fontFamily: theme.fonts.poplar,
            color: theme.colors.latte_cream,
            fontSize: 'max(5vh,5vw)',
            textAlign: "center",
            fontWeight: 'bold',
        },
        imgMixologist:{
            width: '100%',
        }
    }
});

export default useChallengeFinalStyle;